/**
 * The shared dialog and sheet close button is 16 px. On a phone the project asks
 * for 44 px, so the chat dialogs pass this to `closeClassName`. It sits in the
 * same corner and leaves every other caller of the shared components alone.
 */
export const TOUCH_CLOSE = "right-1 top-1 flex h-11 w-11 items-center justify-center p-0 md:right-3 md:top-3 md:h-auto md:w-auto md:p-1";
